import React, { useState } from 'react';
import {EuiButton, EuiFilePicker, EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiPanel, EuiProgress, EuiSpacer, EuiTextColor} from '@elastic/eui';

export const FormularioAImportar = (props)=>{
  
  let {onSave, isUpload, onClose} = props
  let [file, setFile] = useState(undefined)

  const getData = () =>{
    return file
  }

  const onSaveData = () =>{
    onSave && onSave(getData())
  }

  const onChange = (importFiles) => {
    setFile(importFiles);
  };

  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
          
            {isUpload ? 
            <EuiFormRow fullWidth displayOnly>
              <EuiPanel paddingSize="l" color="subdued">
              <strong>Se está realizando la importación....</strong>
              </EuiPanel>
            </EuiFormRow>
            :
            <EuiFormRow fullWidth>
            <EuiFilePicker
                disabled={isUpload}
                fullWidth
                id="fileUploadpicker"
                multiple={false}
                accept={['.xls', '.xlsx']}
                initialPromptText="Selecciona o arrastra el archivo a importar"
                onChange={onChange}
              />
              </EuiFormRow>
            }
          
        </EuiFlexItem>
      </EuiFlexGroup>

      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiTextColor color="primary">{"* Archivos soportados (.xls, .xlsx)"}</EuiTextColor>
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer size="m" />
      
    <EuiFormRow fullWidth>
      {isUpload ? 
      <EuiProgress size="m" color="subdued" />
      :
      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiButton fullWidth onClick={onSaveData} disabled={file===undefined || file.length===0}>
            Guardar
          </EuiButton>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiButton fullWidth color="danger" onClick={()=>onClose()} >Cancelar</EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
      }
    </EuiFormRow>
    </>
  )
}
export default FormularioAImportar